<template>
  <PageContent>
    <div class="pb-1">
      <b-button
        @click.prevent="createMarqueeModal()"
        type="is-primary"
        size="is-small"
        rounded
        :style="{
          ...(breakpoint === 'desktop'
            ? {}
            : {
                width: '100%'
              })
        }"
      >
        Add Marquee Announcement
      </b-button>
    </div>
    <div>
      <ModernTable
        :region="region"
        :filters="filters"
        :rows="rows"
        :columns="columns"
        :pagination="{
          perPage: 12
        }"
        :loading="loading"
        htmlColumn="Announcement"
      />
    </div>
    <Modal :toggle.sync="toggle">
      <MarqueeAnnouncementModal :marquee="selectedMarquee"> </MarqueeAnnouncementModal>
    </Modal>
  </PageContent>
</template>

<script>
import PageContent from '@/containers/PageContent'
import ModernTable from '@/components/tables/Modern/Table'
import MarqueeAnnouncementModal from './components/marqueeAnnouncementModal'
import Modal from '@/components/Modal'
import { mapState, mapGetters } from 'vuex'
import { methods } from '../marqueeAnnouncements/keys/methods'
import { data } from '../marqueeAnnouncements/keys/data'

export default {
  name: 'MarqueeAnnouncementList',
  components: {
    PageContent,
    ModernTable,
    MarqueeAnnouncementModal,
    Modal
  },

  computed: {
    ...mapState({
      hoaId: state => state.user.selectedHoaId,
      ...mapGetters('user', ['authUser']),
      breakpoint: state => (state && state.win ? state.win.breakpoint : null)
    })
  },

  data,

  methods,

  async mounted() {
    await this.reload()
  },

  watch: {
    hoaId() {
      this.reload()
    },
    toggle() {
      if (this.toggle == false) {
        this.reload()
        this.toggle = false
        if (this.Modal && this.Modal != undefined) {
          this.Modal.$emit('update:toggle', (this.toggle = false))
        }
      }
    }
  },

  i18n: {
    messages: {
      en: {
        marqueeAnnouncement: {
          title: 'Marquee Announcements'
        }
      }
    }
  }
}
</script>

<style></style>
